import { __assign } from "tslib";
import React, { useCallback, useState } from 'react';
import { Box, COLOR_VARIANTS, Icons, color } from '@tajawal/ct-web-design-system';
import useCurrency from '../hooks/useCurrency';
var styles = {
    currencySelectorContainer: {
        paddingLeft: '8px',
        paddingRight: '8px',
        position: 'relative'
    },
    currencySelectorButton: {
        cursor: 'pointer',
        zIndex: 212,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    currencyListDropdownBackground: {
        width: '100%',
        height: '100%',
        inset: '0px',
        background: 'rgba(0, 0, 0, 0.5)',
        position: 'fixed',
        zIndex: 210
    },
    currencyListDropdownContainer: {
        position: 'absolute',
        top: '40px',
        right: '8px',
        background: 'white',
        color: '#333333',
        zIndex: 211,
        border: "1px solid ".concat(color(COLOR_VARIANTS.AQUA100)),
        borderRadius: '4px'
    }
};
function CurrencyDropdown(_a) {
    var currencyStore = _a.currencyStore, language = _a.language, onCurrencyChange = _a.onCurrencyChange, partnerReferer = _a.partnerReferer, currencyList = _a.currencyList;
    var currentCurrency = currencyStore.currentCurrency;
    var currenciesList = useCurrency({ currencyStore: currencyStore, currencyList: currencyList }).currenciesList;
    var _b = useState(false), isDropdownOpen = _b[0], setIsDropdownOpen = _b[1];
    var handleCurrencySelectorClick = useCallback(function () {
        setIsDropdownOpen(!isDropdownOpen);
    }, []);
    var handleCurrencyBackgroundClick = useCallback(function () {
        setIsDropdownOpen(false);
    }, []);
    var handleChangeCurrency = useCallback(function (currency) {
        onCurrencyChange(currency.code);
        setIsDropdownOpen(false);
    }, []);
    return (React.createElement(Box, { sx: styles.currencySelectorContainer },
        React.createElement(Box, { testId: "Header__CurrencySelector", sx: styles.currencySelectorButton, onClick: handleCurrencySelectorClick },
            currentCurrency,
            ' ',
            isDropdownOpen ? (React.createElement(Icons.ChevronUp, { width: "16", height: "16" })) : (React.createElement(Icons.ChevronDown, { width: "16", height: "16" }))),
        isDropdownOpen && (React.createElement(React.Fragment, null,
            React.createElement(Box, { onClick: handleCurrencyBackgroundClick, sx: styles.currencyListDropdownBackground }),
            React.createElement(Box, { sx: __assign(__assign({}, styles.currencyListDropdownContainer), (partnerReferer
                    ? { borderColor: color(COLOR_VARIANTS.HEADERTEXT) }
                    : {})) }, currenciesList.map(function (currency) {
                return (React.createElement(Box, { key: currency.code, testId: "CurrencySelection__".concat(currency.code), onClick: function () { return handleChangeCurrency(currency); }, 
                    // @ts-ignore
                    partnerReferer: partnerReferer, sx: {
                        whiteSpace: 'nowrap',
                        cursor: 'pointer',
                        display: 'block',
                        padding: '12px 24px',
                        fontSize: '14px',
                        fontWeight: '400',
                        lineHeight: '1.4',
                        color: '#333333',
                        '&:active': {
                            backgroundColor: color(COLOR_VARIANTS.ALICE),
                            color: '#333333'
                        },
                        '&:hover': {
                            backgroundColor: partnerReferer
                                ? color(COLOR_VARIANTS.HEADERTEXT)
                                : color(COLOR_VARIANTS.AQUA100),
                            color: '#ffffff'
                        }
                    } },
                    React.createElement("strong", null, currency.code),
                    ' ',
                    language === 'en' ? currency.name : currency.name_ar));
            }))))));
}
export default CurrencyDropdown;
//# sourceMappingURL=CurrencyDropdown.js.map